import React from 'react';

const Coil: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C5.06012 2 3 3.95383 3 6C3 8.04617 5.06012 10 8 10C10.9399 10 13 8.04617 13 6C13 3.95383 10.9399 2 8 2ZM1 6C1 2.52332 4.31247 0 8 0C11.6875 0 15 2.52332 15 6C15 9.47668 11.6875 12 8 12C4.31247 12 1 9.47668 1 6Z"
      />
      <path d="M9 6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6C7 5.44772 7.44772 5 8 5C8.55228 5 9 5.44772 9 6Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6C10 7.10457 9.10457 8 8 8C6.89543 8 6 7.10457 6 6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.31206 20.9964C5.21207 21.5964 6.51303 22 8 22C9.48697 22 10.7879 21.5964 11.6879 20.9964C12.5949 20.3917 13 19.6662 13 19H15C15 20.543 14.0619 21.8174 12.7973 22.6605C11.5258 23.5082 9.82674 24 8 24C6.17326 24 4.47422 23.5082 3.20266 22.6605C1.93809 21.8174 1 20.543 1 19H3C3 19.6662 3.40506 20.3917 4.31206 20.9964Z"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M1 19V6H3V19H1Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M13 19V6H15V19H13Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.523 2H8V0H23.477L22.0852 3.47953L23.0943 5.75L22.0852 8.02047L23.077 10.5L22.0852 12.9795L23.0943 15.25L22.0852 17.5205L23.477 21H14.381V19H20.523L19.9148 17.4795L20.9057 15.25L19.9148 13.0205L20.923 10.5L19.9148 7.97953L20.9057 5.75L19.9148 3.52047L20.523 2Z"
      />
    </svg>
  );
};

export default Coil;
